import * as types from './types';
import { conf as globalConfig, Field, Resource, getAvailAssoc } from 'src/config';
import _, { Dictionary } from 'lodash';

export const getResponsePage: (res?: types.Response) => number = (res) => {
    if (res !== undefined) {
        const offset: number | null = res.offset !== null ? res.offset : null;
        const limit: number | null = res.limit !== null ? res.limit : null;
        if (offset !== null && limit !== null) {
            return offset / limit;
        }
    }

    return 0;
}

export const getSortQueryStr: (order: types.SortCol[]) => string | null = (order) => {
    return order.length > 0 ? order.reduce((acc, val) => {
        acc.push(val.path + ',' + val.direction);
        return acc;
    }, [] as string[]).join(';') : null;
}

export const parseSortQueryStr: (orderStr?: string) => types.SortCol[] = (orderStr) => {
    return orderStr != null ? orderStr.split(';').reduce((acc, order) => {
        const [path, dir] = order.split(',');
        acc.push({
            path,
            direction: dir == 'desc' ? types.SortOrder.Desc : types.SortOrder.Asc
        })
        return acc;
    }, [] as types.SortCol[]) : [];
}

export const getInitialAttributes: (resourceName: string, hidden?: boolean) => Dictionary<Field> = (resourceName, hidden = false) => {
    return _.pickBy(globalConfig.getFields(resourceName), (val, key) => {
        return key == '_locked' || (!val.writeOnly && (!val.hidden || hidden));
    });
}

export const getInitialRequest: (resourceName: string, hidden?: boolean) => types.Request = (resourceName, hidden = false) => {
    return {
        resourceName,
        attributes: getInitialAttributes(resourceName, hidden),
        order: [],
        pageSpec: {
            offset: 0,
            limit: 25,
        }
    }
}

export const parseAttrubutes: (resourceName: string, attrs: string) => Dictionary<Field> = (resourceName, attrs) => {
    return attrs.split(',').reduce((dictionary, attr) => {
        const field: Field = findField(resourceName, attr.split('.'));
        dictionary[attr] = field;
        return dictionary;
    }, {} as Dictionary<Field>);
}

const findField: (resourceName: string, path: string[]) => Field = (resourceName, path) => {
    if (path.length == 1) {
        return globalConfig.getFields(resourceName)[_.head(path)!];
    } else {
        const nextResource: Resource = getAvailAssoc(resourceName, true)[_.first(path)!];
        return findField(nextResource.name, _.tail(path));
    }
}

/**
 * This method is taken from https://medium.com/yellowcode/download-api-files-with-react-fetch-393e4dae0d9e
 * 
 * @param blob 
 */
export const downloadBlob: (blob: any) => void = (blob) => {
    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `export.json`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode!.removeChild(link);
}
